import React, { useState } from 'react';
import { Button, Space } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { exportToCSV, getUsersList } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';
import { useNavigate } from 'react-router';

const ChatBotCustomers = () => {
    const navigate = useNavigate();
    const [exportData, setExportData] = useState([])
    const columns = [
        {
            title: 'First Name',
            dataIndex: 'first_name',
            key: 'first_name',
        },
        {
            title: 'Last Name',
            dataIndex: 'last_name',
            key: 'last_name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Button onClick={() => navigate('/customerchat/' + data?._id)} icon={<EyeOutlined />} size="small">View</Button>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Customers</h1>
            </div>
            <TableComponent
                listData={getUsersList}
                roleType="user"
                columns={columns}
                placeholder="Search customers..."
            />
        </div>
    );
};

export default ChatBotCustomers;